/**
 * X - cross browser support helpers
 * by bernhard.buecherl@arrabiata.de
 */
var X = module.exports = {
  // shim reference to the body
  body: document.body || document.documentElement,

  // list of vendor prefixes
  prefixes: ["Moz", "Webkit", "Khtml", "O", "ms", "Icab"],

  // checker for support of css properties
  supportsCSSProperty: function(prop) {
    var style = X.body.style;

    if(!style) {
      return false;
    }
    if(typeof style[prop] !== "undefined") {
      return true;
    }
    for(var i = 0; i < X.prefixes.length; ++i) {
      var vprop = X.prefixes[i] + prop.charAt(0).toUpperCase() + prop.substr(1);
      if(typeof style[vprop] !== "undefined") {
        return true;
      }
    }
    return false;
  },

  // shim #.addEventListener(#,#,#)
  addEventListener: function(el, event, funct) {
    if(el.addEventListener) {
      el.addEventListener(event, funct, false);
    } else if(el.attachEvent) {
      el.attachEvent("on" + event, funct);
    }
  },
  // shim #.removeEventListener(#,#,#)
  removeEventListener: function(el, event, funct) {
    if(el.removeEventListener) {
      el.removeEventListener(event, funct, false);
    } else if(el.detachEvent) {
      el.detachEvent("on" + event, funct);
    }
  },

  // get the current scroll position {x, y}
  scrollPosition: function() {
    var supportPageOffset = window.pageXOffset !== undefined;
    var isCSS1Compat = ((document.compatMode || "") === "CSS1Compat");

    var x = supportPageOffset ? window.pageXOffset : isCSS1Compat ?
        document.documentElement.scrollLeft : document.body.scrollLeft;
    var y = supportPageOffset ? window.pageYOffset : isCSS1Compat ?
        document.documentElement.scrollTop : document.body.scrollTop;
    return {x: x, y: y};
  },

  // cross-browser offsetWidth
  offsetWidth: function(el) {
    return el.offsetWidth || el.clientWidth || 0;
  },

  // cross-browser offsetHeight
  offsetHeight: function(el) {
    return el.offsetHeight || el.clientHeight || 0;
  },

  // cross-browser window.getComputedStyle(prop)
  getCSSProperty: function(el, prop) {
    if(prop in el.style) {
      return el.style[prop];
    } else if("getComputedStyle" in window) {
      return window.getComputedStyle(el).getPropertyValue(prop);
    } else {
      return el.currentStyle[prop];
    }
  },

  // traverse to the next/previous node
  findElementInSameParent: function(dir, element) {
    do {
      element = element[dir + "Sibling"];
    } while(element && element.nodeType !== Node.ELEMENT_NODE);
    return element;
  }
}
